import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Images from "../../../constant/Images";
import { EditFaqinput } from "../../../constant/string";
import services from "../../../services/services";
import InputComponent from "../../inputComponent/InputComponent";
import SelectComponent from "../../selectComponent/SelectComponent";
import {
  MultiLangInputComponent,
  validateMultilingualData,
} from "../page/FaqUtils";
interface LanguageTextPair {
  language: string;
  text: string;
}
interface FaqFormValues {
  topQuestion: LanguageTextPair[];
  description: LanguageTextPair[];
  name: LanguageTextPair[];
  tourId: string;
}
const FaqEdit = ({ data, getdata }: any) => {
  const [missingError, setMissingError] = useState(false);
  const faqDetails = useMemo(() => {
    return {
      name: JSON.parse(data?.name || []),
      tourId: data?.tourId,
      description: JSON.parse(data?.description || []),
      topQuestion: JSON.parse(data?.topQuestion || []),
    };
  }, [data]);

  const [faqData, setFaqData] = useState<any>(faqDetails);

  const { Tours } = useSelector((state: any) => state.tours);
  const [showModal, setShowModal] = React.useState(false);
  const handleAddPlaces = async (payload: any) => {
    const res: any = await services.editFaq(data?.id, payload);
    if (res?.status == 200) {
      toast.success(res?.data.message);
      getdata();
    } else {
      toast.dismiss();
      toast.error("Something Went Wrong");
    }
  };
  useEffect(() => {
    if (showModal) {
      setFaqData(faqDetails);
    }
  }, [showModal]);
  const formik = useFormik({
    initialValues: faqData,
    validationSchema: Yup.object({
      tourId: Yup.string().trim().required("This field is required"),
      topQuestion: Yup.array()
        .of(
          Yup.object({
            language: Yup.string().required("Language is required"),
            text: Yup.string().trim().required("Question is required"),
          })
        )
        .min(1, "At least one question is required"),
      description: Yup.array()
        .of(
          Yup.object({
            language: Yup.string().required("Language is required"),
            text: Yup.string().trim().required("Answer is required"),
          })
        )
        .min(1, "At least one answer is required"),
      name: Yup.array()
        .of(
          Yup.object({
            language: Yup.string().required("Language is required"),
            text: Yup.string().trim().required("Filter name is required"),
          })
        )
        .min(1, "At least one filter name is required"),
    }),
    onSubmit: async (values) => {
      try {
        const isValid = validateMultilingualData({
          answer: values.description,
          question: values.topQuestion,
          filterName: values.name,
        });
        if (isValid) {
          await handleAddPlaces({
            ...values,
          });
          setShowModal(false);
          setMissingError(false);
        } else {
          setMissingError(true);
          console.error(
            "Validation failed: Missing fields for some languages."
          );
        }
      } catch (error) {
        console.error("Error in Formik onSubmit:", error);
      }
    },
    enableReinitialize: true,
  });
  const handleAddFaqValue = (name: any) => {
    const valueFilter = formik.values["name"];
    const valueAns = formik.values["description"];
    const valueQues = formik.values["topQuestion"];
    if (valueFilter.length > 0) {
      const lastItem = valueFilter[valueFilter.length - 1];

      if (!lastItem.language && !lastItem.text) {
        return; // Prevent adding a new entry if the last one is empty
      }
    }

    const updatedValueFilter = [...valueFilter, { language: "", text: "" }];
    const updatedValueAns = [...valueAns, { language: "", text: "" }];
    const updatedValueQues = [...valueQues, { language: "", text: "" }];
    formik.setFieldValue("name", updatedValueFilter);
    formik.setFieldValue("description", updatedValueAns);
    formik.setFieldValue("topQuestion", updatedValueQues);
  };

  const removeHandler = (name: keyof FaqFormValues, index: number) => {
    const value = formik.values[name] as LanguageTextPair[];

    if (!value || !value[index]) return;

    const targetLanguage = value[index].language;
    const fields: (keyof FaqFormValues)[] = [
      "name",
      "description",
      "topQuestion",
    ];

    fields.forEach((fieldName) => {
      const fieldValue = formik.values[fieldName];
      if (Array.isArray(fieldValue)) {
        const updated = fieldValue.filter(
          (item: LanguageTextPair) => item.language !== targetLanguage
        );
        formik.setFieldValue(fieldName, updated);
      }
    });
  };

  type LanguageTextPair = { language: string; text: string };

  const handleSelectedLang = (ind: number, language: string) => {
    const fields: (keyof FaqFormValues)[] = [
      "name",
      "description",
      "topQuestion",
    ];

    fields.forEach((fieldName) => {
      const fieldValue = formik.values[fieldName];

      if (!Array.isArray(fieldValue)) return;

      let updatedValues: LanguageTextPair[] = [];

      if (fieldValue[ind]) {
        // Update the specific index with new language and empty text
        updatedValues = fieldValue.map((item, index) =>
          index === ind ? { ...item, language } : item
        );
      } else {
        // Push a new item at the end if index does not exist
        updatedValues = [...fieldValue, { text: "", language }];
      }

      formik.setFieldValue(fieldName, updatedValues);
    });
  };
  return (
    <>
      <img
        className="font-roboto font-medium text-xl  w-6 h-6 cursor-pointer"
        src={Images.edit}
        alt=""
        onClick={() => {
          setShowModal(true);
          formik.handleReset(formik.values);
        }}
      />
      {showModal ? (
        <>
          <div className="justify-center  box-border  items-center flex  fixed inset-0 z-50 outline-none">
            <div className="relative w-[950px] h-[600px] bg-white my-6 rounded overflow-y-auto ">
              {/*content*/}
              {/*header*/}
              <div className="flex justify-between text-xl font-semibold bg-lightaqua w-[100%] h-[70px] items-center rounded">
                <div></div>
                <h3 className="font-sans font-bold">Add Places</h3>
                <div className="bg-aquadark w-[70px] h-[70px] rounded-xl flex justify-center ">
                  <button
                    className="p-1"
                    onClick={() => {
                      formik.handleReset(formik.values);
                      setShowModal(false);
                    }}
                  >
                    <img
                      className=" text-black h-7 w-7 outline-none focus:outline-none "
                      src={Images.closecircle}
                      alt=""
                    ></img>
                  </button>
                </div>
              </div>
              {/*body*/}
              <form className="px-12 py-9 " onSubmit={formik.handleSubmit}>
                <div className="">
                  {EditFaqinput.map((elm: any) =>
                    elm?.key == "option" ? (
                      <SelectComponent
                        id={elm?.name}
                        landing={true}
                        handlechange={(e: any) =>
                          formik.setFieldValue(elm?.name, e.target.value)
                        }
                        value={(formik as any)?.values?.[elm?.name]}
                        name={elm?.name}
                        label={elm?.label}
                        placeholder={elm?.placeHolder}
                        type={elm?.type}
                        key={elm?.key1}
                        error={(formik as any).errors[elm.name]}
                        touched={(formik as any).touched[elm.name]}
                        option={
                          elm?.key1 == "tourId"
                            ? Tours?.data?.data
                            : elm?.option
                        }
                      />
                    ) : elm.text === "multiLangText" ? (
                      <MultiLangInputComponent
                        key={elm?.name}
                        name={elm?.name}
                        label={elm?.label}
                        value={(formik as any)?.values?.[elm?.name]}
                        setFieldValue={formik.setFieldValue}
                        error={(formik as any).errors[elm.name]}
                        touched={(formik as any).touched[elm.name]}
                        handleAdd={() =>
                          handleAddFaqValue(elm.name as keyof FaqFormValues)
                        }
                        handleRemove={(index: number) =>
                          removeHandler(elm.name as keyof FaqFormValues, index)
                        }
                        handleSelectLang={(ind: number, value: string) =>
                          handleSelectedLang(ind, value)
                        }
                      />
                    ) : (
                      <InputComponent
                        id={elm?.name}
                        handlechange={formik.handleChange}
                        accept={elm?.accept}
                        value={(formik as any)?.values?.[elm?.name]}
                        name={elm?.name}
                        label={elm?.label}
                        placeholder={elm?.placeHolder}
                        type={elm?.type}
                        error={(formik as any).errors[elm.name]}
                        touched={(formik as any).touched[elm.name]}
                      />
                    )
                  )}
                </div>
                {missingError && (
                  <p className=" text-red-500">
                    Validation failed: Missing fields for some languages.
                  </p>
                )}
                <div className="mt-9 flex">
                  <button
                    className="w-[150px] h-[50px] border rounded border-aqua  text-aqua"
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      formik.handleReset(formik.values);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="w-[150px] h-[50px] border rounded bg-aqua text-white ml-6"
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </form>
              {/*footer*/}
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};
export default FaqEdit;
